export function isDefined(val: any): boolean {
  return val !== null && val !== undefined;
}
